import VdpPage, { PresentVdpPageProps } from 'components/VdpPage';
import { fetchAdInfo, fetchVehicleWithExperience } from 'lib/AutolistAPI';
import getIpAddress from 'lib/getIpAddress';
import {
  buildVdpPageProps,
  extractVehicleWithExperienceParamsFromQuery,
} from 'lib/hooks/useBuildVdpPageProps';
import i18next from 'lib/i18next';
import { serverSideMaxMindGeolocate } from 'lib/location/Geolocate';
import { inIframe } from 'lib/Utilities';
import { GetServerSideProps } from 'next';
import { useEffect } from 'react';
import XOR from 'lib/types/xor';

export type VdpOrNotFoundParams = {
  vin: string;
};

const VehicleNotFound = (): JSX.Element => {
  useEffect(() => {
    if (inIframe()) {
      window.parent.postMessage('not found', '*');
    }
  }, []);
  return <div />;
};

type VdpOrNotFoundGetServerSideProps = GetServerSideProps<VdpOrNotFoundProps, VdpOrNotFoundParams>;

export const getServerSideProps: VdpOrNotFoundGetServerSideProps = async ({
  query,
  req,
  res,
  locale = i18next.language,
}) => {
  const ip = await getIpAddress(req);
  let reqLocation;
  if (ip) {
    reqLocation = await serverSideMaxMindGeolocate(ip);
  }

  const params = {
    latitude: reqLocation?.latitude,
    longitude: reqLocation?.longitude,
    locale,
    ...extractVehicleWithExperienceParamsFromQuery(query),
  };

  let vehicleWithExp;
  try {
    vehicleWithExp = await fetchVehicleWithExperience(params);
  } catch (e) {
    console.error(e);
  }

  if (!vehicleWithExp || !vehicleWithExp.vehicle || !vehicleWithExp.vehicle.active)
    return { props: { vehicle: null } };

  let adInfo;
  try {
    adInfo = await fetchAdInfo(params.vin);
  } catch (e) {
    console.error(e);
  }

  if (process.env.DISABLE_VDP_IFRAME_SECURITY === 'true') {
    res.removeHeader('x-frame-options');
  }
  res.setHeader('Cache-Control', 'public, max-age=900, must-revalidate');

  return {
    props: buildVdpPageProps(query, vehicleWithExp, adInfo),
  };
};

export type VdpOrNotFoundProps = XOR<PresentVdpPageProps, { vehicle: null }>;

const VdpOrNotFound = (props: VdpOrNotFoundProps): JSX.Element => {
  if (props?.vehicle && props?.experience) {
    return <VdpPage {...props} />;
  }
  return VehicleNotFound();
};

export default VdpOrNotFound;
